/* eslint-disable react-func/max-lines-per-function */
/* eslint-disable no-console */
import lookie from 'lookie';
import dayjs from 'dayjs';
import posthog from 'posthog-js';
import CryptoJS from 'crypto-js';
import Nprogress from 'nprogress';
import { formatParams2QueryString, Toast } from '@/utils';
import { CURRENT_ANDROID_ID, CURRENT_ORDER_IS_DRAFT, SIGNATURE_SECRET, TOKEN_IDENTIFY } from '@/constant';
import { RestfulInstance } from './common';
import service from './index';
import { ERR_CODE_2_TEXT } from './utils/errorHandler';

const DATE_FORMAT = 'MM-DD HH:mm:ss';
let tryLoginTimes = 0;
const MAX_TRY_LOGIN_TIMES = 30;

type ResponseWithData<T> = {
  code: number;
  data: T;
  message: string;
};

/** HTTP 请求方法 */
interface Method {
  /** HTTP 请求 OPTIONS */
  OPTIONS;
  /** HTTP 请求 GET */
  GET;
  /** HTTP 请求 HEAD */
  HEAD;
  /** HTTP 请求 POST */
  POST;
  /** HTTP 请求 PUT */
  PUT;
  /** HTTP 请求 PATCH */
  PATCH;
  /** HTTP 请求 DELETE */
  DELETE;
  /** HTTP 请求 TRACE */
  TRACE;
  /** HTTP 请求 CONNECT */
  CONNECT;
}

interface RequestParams {
  path: string;
  query?: {
    [key: string]: any;
  };
  method?: keyof Method;
  data?: any;
  config?: Partial<{
    ignoreLogin: boolean;
    ignoreErrorMessage: boolean;
    isGatewayApi: boolean;
    needToken: boolean;
  }>;
}

export const IS_PROD_ENV = __BUILD_ENV__ === 'prod';

const generateRequestUrl = (params: { path: string; query?: RequestParams['query']; isGatewayApi: boolean }) => {
  const { path, query, isGatewayApi } = params || {};

  const urlQuery = formatParams2QueryString(query) || '';

  return {
    fullPath: (isGatewayApi ? '/auth' : '/api') + path + urlQuery,
    tailPath: path + urlQuery,
  };
};
const handleLogin = () => {
  return new Promise(async (resolve, reject) => {
    tryLoginTimes += 1;
    if (tryLoginTimes > MAX_TRY_LOGIN_TIMES) {
      return reject('max times limited');
    }
    try {
      const timestamp = new Date().getTime();
      const androidId = lookie.get(CURRENT_ANDROID_ID);
      const signature = CryptoJS.MD5(SIGNATURE_SECRET + androidId + timestamp).toString();
      const { data: token } = await service.user.login({
        signature,
        androidId,
        timestamp,
      });
      lookie.set(TOKEN_IDENTIFY, token);
      resolve('');
    } catch (e) {
      reject(e);
    }
  });
};

export function request<Res, Req = any>(params: RequestParams): Promise<ResponseWithData<Res>> {
  return new Promise((resolve, reject) => {
    const { path, query, data, config, method = 'GET' } = params;
    const { ignoreErrorMessage, isGatewayApi = false, needToken = true } = config || {};

    Nprogress.start();

    const { fullPath, tailPath } = generateRequestUrl({ path, query, isGatewayApi }) || {};

    if (!IS_PROD_ENV) {
      const reqTime = dayjs().format(DATE_FORMAT);

      console.log(`%c Req ${tailPath} [${reqTime}]`, 'color:  #2476fa', data);
    }

    const handleSendRequest = () => {
      const currentOrderIsDraft = !!lookie.get(CURRENT_ORDER_IS_DRAFT);

      RestfulInstance({
        method,
        url: fullPath,
        data,
        headers: {
          ...(needToken ? { pad_auth_token: lookie.get(TOKEN_IDENTIFY) || '' } : {}),
          ...(currentOrderIsDraft ? { simulation: true } : {}),
        },
      })
        .then(resData => {
          const newToken = resData?.headers?.token;

          // 当本地token快要过期时后端header会携带新的token，执行替换操作
          newToken && lookie.set(TOKEN_IDENTIFY, newToken);

          const { status, data } = resData || {};

          if (status !== 200) {
            const message = [401, 403].includes(status) ? '请登录' : resData?.data?.error || '网络异常';
            !ignoreErrorMessage && Toast.fail(message);
            reject({ code: status, message });
            return;
          }

          if (!IS_PROD_ENV) {
            const resTime = dayjs().format(DATE_FORMAT);
            console.log(`%c Res: ${tailPath} [${resTime}]`, 'color: #f64352', data);
            //@ts-ignore
            // 测试阶段先注释掉日志，避免日志过多，看网络请求是否可以收集到
            // posthog.sessionRecording?.log({
            //   type: 'api-log',
            //   url: tailPath,
            //   time: resTime,
            //   data,
            // });
          }

          const { code: businessCode, message } = data || {};

          if (businessCode === 200) {
            resolve(data);
          } else {
            !ignoreErrorMessage && Toast.fail(message || '请求异常');
            reject({ data: null, code: businessCode, message: message || '请求异常' });
          }
        })
        .catch(error => {
          console.log(`%c Res: ${tailPath}`, 'color: #f64352', error);
          if ([401, 403].includes(error?.response?.status ?? error?.code)) {
            handleLogin()
              .then(() => {
                handleSendRequest();
              })
              .catch(e => {
                console.error('重新登录失败', e);
                reject({ code: error?.response?.status || error?.code, message: error?.message });
              });
            return;
          }

          !ignoreErrorMessage &&
            Toast.fail(
              error?.response?.data?.messagae ||
                ERR_CODE_2_TEXT[error?.code] ||
                error?.message ||
                error?.msg ||
                '未知错误'
            );
          reject({ code: error?.response?.status || error?.code, message: error?.message });
        })
        .finally(() => {
          Nprogress.done();
        });
    };

    handleSendRequest();
  });
}
